import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  formControlLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginLeft: 0,
    gap: theme.spacing(1),
  },
  headerBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.spacing(1),
  },
  titleRow: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'flex-start',
  },
  helpIcon: {
    cursor: 'help',
  },
  statusLabel: {
    textTransform: 'uppercase',
    fontWeight: 600,
  },
}))

export default useStyles
